export default __webpack_public_path__ + "static/media/SWT0030.34I-27132_-16413_0.3a2433b9.jpg";